import { SubpropertyService } from '@modules/subproperty/subproperty-service';
import RelationToOneField from '@shared/fields/relation-to-one-field';
import RelationToManyField from '@shared/fields/relation-to-many-field';
import Permissions from '@security/permissions';


export class SubpropertyField {
  static relationToOne(name, label, options) {
    return new RelationToOneField(
      name,
      label,
      '/subproperty',
      Permissions.values.subpropertyRead,
      SubpropertyService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.name,
          roles: record.roles  ?  record.roles : []

        };
      },
      options,
    );
  }

  static relationToMany(name, label, options) {
    return new RelationToManyField(
      name,
      label,
      '/subproperty',
      
      Permissions.values.subpropertyRead,
      SubpropertyService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }
   
        return {
          id: record.id,
          label: record.name,
          roles:  []
        };
      },
      options,
    );
  }
}
